<template>
    <div>
        <el-form label-width="120px" label-position="left" :rules="rules" :inline="true" :model="upData"
            class="query-form" ref="dataForm">
            <h1 class="inquiryDetailsTitle" style="position: relative;display: flex;align-items: center;">礼品信息
                <el-button style="width: 80px;position: absolute;right: 20px;" @click.native="goback">返回</el-button>
            </h1>
            <el-form-item v-if="isEdit==0" class="query-form-item" label="礼品名称:">
                <template>{{ giftDetail.name}}</template>
            </el-form-item>
            <el-form-item v-if="isEdit==1" class="query-form-item" label="礼品名称:" prop="name">
                <el-input v-model="upData.name" placeholder="请输入礼品名称" clearable></el-input>
            </el-form-item>

            <el-form-item v-if="isEdit==0" class="query-form-item" label="礼品编码:">
                <template>{{ giftDetail.giftCode }}</template>
            </el-form-item>
            <el-form-item v-if="isEdit==1" class="query-form-item" label="礼品编码:" prop="giftCode">
                <el-input v-model="upData.giftCode" onkeyup="value=value.replace(/[^\d]/g,'')"  maxlength="8" placeholder="填写8位数的数字编码" clearable></el-input>
            </el-form-item>

            <el-form-item v-if="isEdit==0" class="query-form-item" label="库存:">
                <template>{{ giftDetail.stock }}</template>
            </el-form-item>
            <el-form-item v-if="isEdit==1" class="query-form-item" label="库存:" prop="stock">
                <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model="upData.stock" maxlength="10" placeholder="请输入库存" clearable></el-input>
            </el-form-item>


            <el-form-item class="query-form-item" label="添加时间:" v-if="isEdit==0">
                <template>{{ giftDetail.createTime | formatDateStr("yyyy-MM-dd hh:mm:ss")  }}</template>
            </el-form-item>


            <el-form-item v-if="isEdit==0" class="query-form-item" label="分类:">
                <template>{{ giftDetail.catalogId }}</template>
            </el-form-item>
            <el-form-item v-if="isEdit==1" class="query-form-item" label="分类:" prop="catalogId">
                <el-select v-model="upData.catalogId" placeholder="请选择分类" clearable style="width:215px;">
                    <el-option v-for="item in classifyData" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>



            <el-form-item v-if="isEdit==0" :class="isEdit==1?'query-form-item query-form-item-big':'query-form-item'"
                label="兑换积分:">
                <template>{{ giftDetail.integralNum }}</template>
            </el-form-item>
            <el-form-item v-if="isEdit==1" :class="isEdit==1?'query-form-item query-form-item-big':'query-form-item'"
                label="兑换积分:" prop="integralNum">
                <el-input maxlength="8" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="upData.integralNum" placeholder="请输入兑换积分" clearable></el-input>
            </el-form-item>


            <!-- 缩略图上传 -->
            <el-form-item v-if="isEdit==0" class="query-form-item query-form-item-big" label="缩略图:">
                <template>
                    <el-popover placement="right" trigger="hover">
                        <img :src="giftDetail.imgUrl" style="width:400px;border-radius:3px;" />
                        <img slot="reference" :src="giftDetail.imgUrl"
                            style="max-height: 50px;max-width: 50px;border-radius:5px;" />
                    </el-popover>
                </template>
            </el-form-item>
            <!-- 缩略图上传 -->
            <el-form-item v-if="isEdit==1" class="query-form-item query-form-item-big" label="缩略图:" prop="imgUrl">
                <template>
                    <el-upload :action="uploadUrl" :headers="{'hfmauth':'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}"
                        list-type="picture-card" :show-file-list="false" ref="upload"
                        accept=".png, .jpg, .gif, .jpeg, .bmp" :on-success="handleAvatarSuccess1"
                        :before-upload="beforeAvatarUpload1">
                        <img v-if="upData.imgUrl" width="100%" height="100%" :src="upData.imgUrl" alt>
                        <i v-else class="el-icon-plus"></i>
                    </el-upload>
                    <span>商品列表展示的图片，图片大小为680*540(px)</span>
                </template>
            </el-form-item>


            <el-form-item v-if="isEdit==0" label="轮播图:" class="query-form-item query-form-item-big">
                <template>
                    <el-popover placement="right" trigger="hover" v-for="item in giftDetail.hfIntegralGiftCarouselList"
                        style="margin-right: 20px;">
                        <img :src="item.carouselurl" style="width:400px;border-radius:3px;" />
                        <img slot="reference" :src="item.carouselurl"
                            style="max-height: 50px;max-width: 50px;border-radius:5px;" />
                    </el-popover>
                </template>
            </el-form-item>

            <!-- 轮播图上传 -->
            <el-form-item v-if="isEdit==1" label="轮播图:" class="query-form-item query-form-item-big" prop="carouselUrl">
                <template>
                    <el-upload :action="uploadUrl" ref="uploadCarouselurl" list-type="picture-card"
                        :show-file-list="true" accept=".png, .jpg, .gif, .jpeg, .bmp" :file-list="upData.carouselUrl"
                        :on-remove="handleRemove" :on-success="uploadSuccess" :multiple="true" :headers="{
                            hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'
                        }"
                        :before-upload="beforeAvatarUpload1"
                        >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span>商品详情页顶部展示的轮播图片，图片大小为680*540(px)</span>
                </template>
            </el-form-item>

            <el-form-item v-if="isEdit==0" class="query-form-item query-form-item-big" label="商品详情:">
                <div class="detailsBox" style="padding: 20px;" v-html="giftDetail.detail"></div>
            </el-form-item>
            <el-form-item v-if="isEdit==1" class="query-form-item query-form-item-big" label="商品详情:" prop="detail">
                <div class="detailsBox">
                    <tinymce style="display: inline-block;width: 100%;" ref="tinymce" :height="500"
                        v-model="upData.detail" />
                </div>
            </el-form-item>

            <el-form-item v-if="isEdit==1" class="query-form-item query-form-item-big"
                style="display: flex;justify-content: flex-end;">
                <el-button type="primary" @click.native="onSubmit()">保存</el-button>
                <el-button @click.native="goback" style="margin-right: 20px;">取消</el-button>
            </el-form-item>

        </el-form>

        <!-- <div slot="footer" style="display: flex;justify-content: flex-end;" v-if="isEdit==1">
            <el-button type="primary" @click.native="onSubmit()">保存</el-button>
            <el-button @click.native="goback">取消</el-button>
        </div> -->
        <!-- <div slot="footer" style="display: flex;justify-content: flex-end;" v-if="isEdit==0">
            <el-button @click.native="goback">返回</el-button>
        </div> -->
    </div>
</template>

<script>
    import {
        BASE_URL
    } from "@/config/app";
    import Tinymce from "@/components/Tinymce/index.vue";
    import {
        getIntegralGiftDetailsApi,
        updateIntegralGiftApi,
        addIntegralGiftApi
    } from "@/api/integral/integral";
    import {
        getGiftCatalogListApi
    } from "@/api/integral/classify";
    export default {

        data() {
            // var detailTitle = (rule, value, callback) => {
            //       if (!value) {
            //           return callback(new Error('请输入商品详情'));
            //       } else {
            //           callback();
            //       }
            //   };
            return {
                loading: false,
                isEdit: 1, // 1编辑模式 0查看
                upData: {
                    imgUrl: "",
                    carouselUrl: []
                },
                carouselUrl: [],
                trueData: {},
                giftDetail: {},
                uploadUrl: BASE_URL + "/upload/tool/uploadpro", // 上传图片路径
                classifyData: [],
                img: '',
                rules: {
                    name: [{
                        required: true,
                        message: '请输入礼品名称',
                        trigger: 'blur'
                    }],
                    catalogId: [{
                        required: true,
                        message: '请选择分类',
                        trigger: 'change'
                    }],
                    giftCode: [{
                        required: true,
                        message: '请输入礼品编码',
                        trigger: 'blur'
                    }],
                    integralNum: [{
                        required: true,
                        message: '请输入兑换积分',
                        trigger: 'blur'
                    }],
                    stock: [{
                        required: true,
                        message: '请输入库存',
                        trigger: 'blur'
                    }],
                    imgUrl: [{
                        required: true,
                        message: '请上传缩略图',
                        trigger: 'change'
                    }],
                    carouselUrl: [{
                        required: true,
                        message: '请上传轮播图',
                        trigger: 'change'
                    }],
                    detail: [{
                        required: true,
                        message: '请填写商品详情',
                        trigger: "blur"
                    }],
                }
            };
        },
        components: {
            Tinymce
        },
        methods: {
            // 缩略图上传
            handleAvatarSuccess1(res, file) {
                console.log('0', res)
                this.upData.imgUrl = res.data
            },
            beforeAvatarUpload1(file) {
                console.log(file);
                // this.upData.imgUrl = ""
                const isJPG =
                file.type === "image/jpeg" ||
                file.type === "image/jpg" || 
                file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error("上图片只能是 JPG/PNG 格式!");
                return false;
            }
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 2MB!");
                return false;
            }
            let imgWidth = "";
            let imgHight = "";
            const isSize = new Promise(function (resolve, reject) {
                let width = 680;
                let height = 540;
                let _URL = window.URL || window.webkitURL;
                let img = new Image();
                img.onload = function () {
                    imgWidth = img.width;
                    imgHight = img.height;
                    let valid = img.width == width && img.height == height;
                    valid ? resolve() : reject();
                };
                img.src = _URL.createObjectURL(file);
            }).then(() => {
                return file;
            },() => {
                this.$message.error("图片尺寸需为650 x 540px。当前上传图片的尺寸为：" +imgWidth +"x" +imgHight +"px");
                return Promise.reject();
                return false;
            });
            return isJPG && isLt2M && isSize;
            },
            handleRemove1(file) {
                console.log(file, fileList);
            },

            // 轮播图上传
            handleRemove(file) {
                console.log(file.url);
                for (var i = 0; i < this.upData.carouselUrl.length; i++) {
                    if (this.upData.carouselUrl[i].url == file.url) {
                        this.upData.carouselUrl.splice(i, 1);
                    }
                }
            },
            uploadSuccess(response) {
                let url = response.data;
                // console.log("轮播图上传路径:" + url);
                this.upData.carouselUrl.push({
                    url: url
                });
                console.log('上传成功后', this.upData.carouselUrl)
            },
            //礼品详情
            getIntegralGiftDetailsFn() {
                let theId = {
                    id: this.upData.id
                }
                getIntegralGiftDetailsApi(theId)
                    .then(res => {
                        console.log("%%%%%%%%%%%%%%%%%", res)
                        this.giftDetail = res.data || {};
                        this.upData = res.data || {};
                        this.upData.carouselUrl = res.data.hfIntegralGiftCarouselList
                        this.upData.carouselUrl = res.data.hfIntegralGiftCarouselList.map(item => {
                            item.url = item.carouselurl
                            return item
                        })
                    })
                    .catch(() => {});
                console.log('000', this.upData.carouselUrl)
            },
            //礼品下所有分类
            getGiftCatalogListFn() {
                getGiftCatalogListApi().then(res => {
                        console.log('分类', res)
                        this.classifyData = res.data;
                        console.log('分类分类', this.classifyData)
                    })
                    .catch(() => {});
            },
            //礼品添加与修改
            onSubmit() {
                if (this.isEdit == 1 && this.upData.id) {
                    this.$refs["dataForm"].validate((valid) => {
                        if (valid) {
                            console.log('修改参数', this.upData)
                            // if(this.upData.integralNum>100000){
                            //   this.$message.error('');
                            //   return
                            // }
                            this.trueData = JSON.parse(JSON.stringify(this.upData));
                            let data = "";
                            this.trueData.carouselUrl.forEach(item => {
                                if (data) {
                                    data += `,` + item.url;
                                } else {
                                    data = item.url
                                }

                            });
                            this.trueData.carouselUrl = data;
                            console.log('datadata', data)
                            console.log('新的修改参数', this.trueData)
                            updateIntegralGiftApi(this.trueData).then(res => {
                                    console.log('修改', res)
                                    if (res.code) {
                                        this.$message.error(res.message);
                                        return false;
                                    }
                                    this.$message.success("操作成功");
                                    this.$router.go(-1)
                                })
                                .catch(() => {});
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });

                } else {
                    this.$refs["dataForm"].validate((valid) => {
                        if (valid) {
                            // if (this.upData.imgUrl == "") {
                            //     this.$message.error('请上传缩略图！');
                            //     return false
                            // }

                            // if (this.upData.carouselUrl == "") {
                            //     this.$message.error('请上传轮播图！');
                            //     return false
                            // }

                            // if (this.upData.detail == "") {
                            //     this.$message.error('请填写商品详情！');
                            //     return false
                            // }
                            // 添加
                            console.log('添加参数', this.upData)
                            this.trueData = JSON.parse(JSON.stringify(this.upData));
                            let data = "";
                            this.trueData.carouselUrl.forEach(item => {
                                if (data) {
                                    data += `,` + item.url;
                                } else {
                                    data = item.url
                                }

                            });
                            this.trueData.carouselUrl = data;
                            console.log('datadata', data)
                            console.log('新的参数', this.trueData)
                            addIntegralGiftApi(this.trueData).then(res => {
                                    console.log('添加', res)
                                    if (res.code) {
                                        this.$message.error(res.message);
                                        return false;
                                    }
                                    this.$message.success("操作成功");
                                    this.$router.go(-1)

                                })
                                .catch(() => {});
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });

                }
            },
            goback() {
                this.$router.go(-1)
            },
        },
        filters: {},
        mounted() {},
        created() {
            this.isEdit = this.$route.query.isEdit;
            this.upData.id = this.$route.query.id;
            //查看
            if (this.isEdit == 0) {
                this.getIntegralGiftDetailsFn();
            } else if (this.isEdit == 1 && this.upData.id) {
                this.getIntegralGiftDetailsFn();
            } else {
                console.log('添加')
            }

            this.getGiftCatalogListFn();
        }
    };

</script>
<style scoped>
    /deep/ .query-form {
        color: #606266;
        max-width: 1200px !important;
        border: 1px solid #f4f4f5;
        border-bottom: none;
        margin-bottom: 40px;
        /* border-left: none; */
    }

    /deep/ .query-form-item {
        /* display: block !important; */
        width: 50% !important;
        margin-right: 0 !important;
        padding: 10px 0;
        margin-bottom: 0 !important;
        border-bottom: 1px solid #f4f4f5;
        /* display: flex !important; */
        /* border-left: 1px solid #F4F4F5; */
    }

    /deep/ .query-form-item-big {
        width: 100% !important;
    }

    /deep/ .el-form-item__label {
        padding-left: 20px;
    }

    /deep/ .query-form-item-big .el-form-item__content {
        /* padding: 0 20px; */
        /* text-indent: 4em; */
    }

    .inquiryDetailsTitle {
        line-height: 50px;
        background: #f4f4f5;
        padding-left: 20px;
    }

    /deep/ .el-table--border {
        width: 1200px;
    }

    /deep/ .el-table__body td {
        padding: 12px 0 !important;
    }

    /deep/ .query-form-item .el-popover__reference-wrapper {
        height: 100% !important;
    }

    /deep/ .detailsBox {
        /* padding: 0 20px 20px 0; */
        width: 1088px;
    }

    /deep/ .detailsBox img {
        display: block;
        max-width: calc(100%);
        height: auto;
        /* border-radius: 20px; */
        margin: 0 auto 20px;
    }

</style>
